import React, { useState, useEffect } from "react";
import "../CSS/TopbarTenagaKesehatan.css";
import { FaBell, FaUserCircle } from "react-icons/fa";

function TopbarLaporKendala() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    setUser(storedUser);
  }, []);

  return (
    <div className="topbar">
      <div className="topbar-left">
        <h2 className="page-title">Laporan Kendala Teknis</h2>
      </div>

      {/* Jika user tersedia */}
      {user ? (
        <div className="user-info">
          <FaBell className="icon" />
          <div className="user-name">
            <p className="name">{user.username || user.nama || "User"}</p>
            <p className="role">{user.profesi || user.Profesi || "-"}</p>
          </div>
          <FaUserCircle className="profile-icon" />
        </div>
      ) : (
        // Fallback jika tidak ada user di localStorage
        <div className="user-info">
          <FaBell className="icon" />
          <div className="user-name">
            <p className="name">User</p>
            <p className="role">-</p>
          </div>
          <FaUserCircle className="profile-icon" />
        </div>
      )}
    </div>
  );
}

export default TopbarLaporKendala;
